// Uncomment this if you are using a bundler like Webpack/Vite
// import $ from 'jquery'; 

export default class Slider {
  constructor() {
    const heroSlider = document.querySelector('.hero-slider');
    const newsSlider = document.querySelector('.news-slider');
    const cardSlider = document.querySelector('.card-slider');
    
    if (heroSlider) {
      this.initEventSlider(heroSlider);
    }
    
    if (newsSlider) {
      this.initNewsSlider(newsSlider);
    }
    if (cardSlider) {
      this.initCardSlider(cardSlider);
    }
    
  }
  
  initEventSlider(heroSlider) {
    const $hero = $(heroSlider);
    
    $hero.slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      speed: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      appendDots: '#dots-container',
      touchThreshold: 10,
      adaptiveHeight: false,
      // Pass the string selector directly. Slick handles the click events natively.
      prevArrow: '.slider-prev', 
      nextArrow: '.slider-next',
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: false,
          }
        }
      ]
    });
    
    // Pause autoplay on mobile touch
    $hero.on('touchstart', function () {
      $(this).slick('slickPause');
    });
    
    // NOTE: Removed manual custom click handlers for .slider-prev/.slider-next 
    // because Slick's internal engine handles them automatically via the keys above.
  }
  
  initNewsSlider(newsSlider) {
    
    var slideCount = $(newsSlider).children().length;
    var controls = $(newsSlider).closest('.container').find('.slider-controls');
    var dots = $('#featured-news-dots');
    
    if (slideCount <= 1) {
      controls.removeClass('d-md-flex').addClass('d-none');
      dots.addClass('d-none');
    }
    
    $(newsSlider).slick({
      infinite: true,
      autoplay: false,
      fade: true,
      speed:0,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '.featured-slider-prev', 
      nextArrow: '.featured-slider-next',
      touchThreshold: 10,
      adaptiveHeight: false,
      dots: true,
      appendDots: '#featured-news-dots',
    });
  }
  
  initCardSlider(cardSlider) {
    var slideCount = $(cardSlider).children().length;
    var controls = $(cardSlider).siblings('.slider-controls');
    
    
    if (slideCount > 4) {
      $(cardSlider).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '.slider-prev', 
        nextArrow: '.slider-next',
        touchThreshold: 10,
        adaptiveHeight: false,
        dots: true,
        appendDots: '#dots-container-2',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false,
              centerMode: false,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              centerMode: false,
            }
          }
        ]
      });
    } else {
      //hide controls
      controls.removeClass('d-flex').addClass('d-none');
      //init slider
      $(cardSlider).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '.slider-prev', 
        nextArrow: '.slider-next',
        touchThreshold: 10,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false,
              centerMode: false,
              dots: true,
              appendDots: '#dots-container-2',
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              centerMode: false,
              dots: true,
              appendDots: '#dots-container-2',
            }
          }
        ]
      });
    }
  }
  
}